"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftRailHeader = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var LeftRailButton_1 = require("../../containers/LeftRailButton/LeftRailButton");
require("./styles.less");
function LeftRailHeader(props) {
    return (React.createElement("header", { className: 'm-left-rail-header' },
        React.createElement("div", { className: 'm-left-rail-header__title' }, "Green Section Record"),
        React.createElement(LeftRailButton_1.LeftRailButton, { url: props.subscribeLink, title: 'Subscribe', colored: true })));
}
exports.LeftRailHeader = LeftRailHeader;
